
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculadora-solar",
      function () {
        return require("private-next-pages/calculadora-solar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculadora-solar"])
      });
    }
  